import script from "./BranchStore.vue?vue&type=script&setup=true&lang=js"
export * from "./BranchStore.vue?vue&type=script&setup=true&lang=js"

import "./BranchStore.vue?vue&type=style&index=0&id=e0c8d1b8&lang=stylus&scoped=true"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c8d1b8"]])

export default __exports__